/**
 * Helpers Functions
 */
import moment from 'moment';
import React, { } from 'react';
import { Link } from 'react-router-dom';
import { decode } from 'html-entities';
import viLocale from "date-fns/locale/vi";
import {
    formatRelative,
    format,
    parseISO
} from "date-fns";
import { vi } from 'date-fns/locale';
import ReactAudioPlayer from 'react-audio-player';
import ReactPlayer from 'react-player'
import { Badge, Image, Space, Tag, Typography } from 'antd';
import ReactJson from 'react-json-view';


import no_image from '../assets/img/no_image.png';
import { CheckCircleTwoTone, CloseCircleTwoTone, EditOutlined } from '@ant-design/icons';
import _ from 'lodash';

const { Text } = Typography;

export function customDataImageUpload(data = [], oldData = []) {
    const arr = [];
    data.map(item => {
        arr.push({ id: Math.random(), src: item })
    })
    if (oldData.length) {
        return [...oldData, ...arr];
    } else {
        return [...arr];
    }
}

export function customDataFilesUpload(newData = [], oldData = []) {
    if (oldData.length) {
        return [...oldData, ...newData];
    } else {
        return [...newData];
    }

}

export function truncateDecimals(num, decimals = 2) {
    try {
        if (isNaN(num) || num === null || num === undefined) {
            throw new Error("Giá trị không hợp lệ");
        }

        const factor = Math.pow(10, decimals);
        return Math.floor(parseFloat(num) * factor) / factor;
    } catch (error) {
        console.error("Lỗi:", error.message);
        return "N/A"; // Giá trị mặc định khi lỗi xảy ra
    }
};


/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
    }
    throw new Error('Bad Hex');
}

/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = '...';
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
}

/**
 * Get Date
 */
export function getTheDate(timestamp, format) {
    let time = timestamp * 1000;
    let formatDate = format ? format : 'MM-DD-YYYY';
    return moment(time).format(formatDate);
}

/**
 * Convert Date To Timestamp
*/
export function convertDateToTimeStamp(date, format) {
    let formatDate = format ? format : 'YYYY-MM-DD';
    return moment(date, formatDate).unix();
}

/**
 * Function to return current app layout
 */
export function getAppLayout(url) {
    let location = url.pathname;
    let path = location.split('/');
    return path[1];
}

/**
 * 
 * @param {int} x 
 * Thousand delimiter
 */
export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

/**
 * 
 * @param {*function} callback 
 * @param {*number} delay 
 * @param  {...any} args 
 * 
 */
export function debounce(callback, delay, ...args) {
    const timerClear = () => clear = true;
    var clear = true;
    return event => {
        if (clear) {
            clear = false;
            setTimeout(timerClear, delay);
            callback(event, ...args);
        }
    }
}


export function capitalize(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

export function getFirstLetterOfWords(str) {
    if (!str) return;
    var acronym = '';
    let temp = str.split(" ");
    if (temp.length >= 2) acronym = temp[temp.length - 2].charAt(0) + temp[temp.length - 1].charAt(0);
    else acronym = str.charAt(0);
    // var matches = str.match(/\b(\w)/g);
    // if(!matches) return str.charAt(0);

    return acronym;
}

export function cleanObject(obj) {
    Object.keys(obj).map(key => {
        if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
            delete obj[key];
        }
    });

    return obj;
}

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export async function getBase64FromUrl(url) {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        }
    });
}

/**
 * render function for breadcrumb
 * @param {*} route 
 * @param {*} params 
 * @param {*} routes 
 * @param {*} paths 
 */
export const itemRender = (route, params, routes, paths) => {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
        <span>{route.breadcrumbName}</span>
    ) : (
        <Link to={`/${paths.join('/')}`}>{route.breadcrumbName}</Link>
    );
}

/**
 * 
 * @param {*} url URL need to download
 * Downlaod without pop-up block warning
 */
export const downloadFromLink = (url) => {
    let link = document.createElement("a");
    //link.download = filename;
    link.href = url;
    link.target = '_blank';
    link.click();
    URL.revokeObjectURL(link.href);
}

/**
 * Format number thousand seperator
 * @param {*} num original number
 */
export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function removeSign(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
    str = str.replace(/Đ/g, "D");
    str = str.replace(/[^0-9a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ\s]/gi, '');
    str = str.replace(/\s+/g, '_');
    str.trim();
    return str;
}

export function convertToSlug(title) {
    var slug;
    //Đổi chữ hoa thành chữ thường , //Decode các ký tự đặc biệt html
    slug = decode(title.toLowerCase());
    //Đổi ký tự có dấu thành không dấu
    slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
    slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
    slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
    slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
    slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
    slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
    slug = slug.replace(/đ/gi, 'd');
    //Xóa các ký tự đặt biệt
    slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
    //Đổi khoảng trắng thành ký tự gạch ngang
    slug = slug.replace(/ /gi, "-");
    //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
    //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
    slug = slug.replace(/\-\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-/gi, '-');
    slug = slug.replace(/\-\-/gi, '-');
    //Xóa các ký tự gạch ngang ở đầu và cuối
    slug = '@' + slug + '@';
    slug = slug.replace(/\@\-|\-\@|\@/gi, '');
    slug = slug.replace(/\s/g, '');
    return slug;
}

// Use Object.sort(dynamicSort('key'))
export function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

export function stripHtml(html) {
    if (typeof html !== 'undefined' && html !== null) {
        // Loại bỏ các thẻ HTML
        let strippedHtml = html.replace(/(<([^>]+)>)/gi, " ");

        // Xóa các ký tự &nbsp;
        strippedHtml = strippedHtml.replace(/\&nbsp;/g, ' ');

        return strippedHtml;
    } else {
        return html;
    }
}

export function _newLine(text) {
    if (typeof text != 'undefined' && text != null) {
        text = text.replace(/<br ?\/?>/g, "\n");
        text = text.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '\n');
        //text = text.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '\n').replace(/\n\s*\n/g, '\n');
        return text;
    } else {
        return text;
    }
}

export function toNewLine(text) {
    if (typeof text != 'undefined' && text != null) {
        text = text.replace(new RegExp('\r?\n', 'g'), '<br />');
        return text;
    } else {
        return text;
    }
}

export const makeTree = (arr, parent) => {
    const branch = arr.filter(node => node.parent_id === parent);
    branch.forEach(node => {
        node.title = node.name
        node.value = node.id
        const children = makeTree(arr, node.id);
        if (children.length) {
            node.children = children;
        }
    });
    return branch;
};

export const makeTreeIdName = (arr, parent) => {
    const branch = arr.filter(node => node.parent === parent);
    branch.forEach(node => {
        node.title = node.name
        node.value = node.id + '|' + node.name
        const children = makeTreeIdName(arr, node.id);
        if (children.length) {
            node.children = children;
        }
    });
    return branch;
};

export function YouTubeGetID(url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
}

export function formatRelativeDate(datetime) {
    let formatDate = '';
    var formatRelativeLocale = {
        lastWeek: "eeee 'tuần trước' 'lúc' p",
        yesterday: "'Hôm qua' 'lúc' p",
        today: "'Hôm nay' 'lúc' p",
        tomorrow: "'Ngày mai' 'lúc' p",
        nextWeek: "eeee 'tuần sau' 'lúc' p",
        other: 'P'
    }

    const locale = {
        ...viLocale,
        formatRelative: token => formatRelativeLocale[token],
    };

    if (datetime) {
        const date = new Date(toTimestamp(datetime) * 1000);
        formatDate = formatRelative(date, new Date(), { locale });
        formatDate = formatDate.charAt(0).toUpperCase() + formatDate.slice(1);

        // Chỉ thêm giờ, phút, giây nếu formatDate không chứa các cụm từ đã bao gồm thời gian
        if (!formatDate.includes('lúc')) {
            const time = format(date, 'HH:mm');
            formatDate = `${formatDate} ${time}`;
        }

        return formatDate;
    }
}

function toTimestamp(strDate) {
    var datum = Date.parse(strDate);
    return datum / 1000;
}

export function isJson(item) {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
}

export function handleAttachmentMessage(attachment_type, message) {
    //console.log("message: ", message)
    if (isJson(message)) {
        if (attachment_type == 'image') {
            var height = "200px";
            if (JSON.parse(message).length > 1) {
                height = "100px";
            }
            return (
                <Image.PreviewGroup>
                    <Space wrap>
                        {
                            JSON.parse(message).map(item => (
                                <Image
                                    height={height}
                                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                                    src={item ? item : no_image}
                                    fallback="data:image/png;base64,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"
                                />
                            ))
                        }
                    </Space >
                </Image.PreviewGroup>
            )
        }
        if (attachment_type == 'file') {
            return JSON.parse(message).map(item => (
                <a href={item} target="_blank">Tệp đính kèm</a>
            ))
        }
        if (attachment_type == 'audio') {
            return JSON.parse(message).map(item => (
                <ReactAudioPlayer
                    src={item ? item : null}
                    autoPlay={false}
                    controls
                    style={{ width: '100%' }}
                    muted={false}
                />
            ))
        }
        if (attachment_type == 'video') {
            return JSON.parse(message).map(item => (
                <ReactPlayer
                    url={item}
                    className='react-player'
                    width='100%'
                    height='100%'
                    controls={true}
                />
            ))
        }
    } else {
        if (attachment_type == 'image') {
            return (
                <Image
                    height="200px"
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                    src={message ? message : no_image}
                />
            )
        }
        if (attachment_type == 'file') {
            return (<a href={message} target="_blank">Tệp đính kèm</a>)
        }
        if (attachment_type == 'audio') {
            return (
                <ReactAudioPlayer
                    src={message ? message : null}
                    autoPlay={false}
                    controls
                    style={{ width: '100%' }}
                    muted={false}
                />
            )
        }
        if (attachment_type == 'video') {
            return (
                <ReactPlayer
                    url={message}
                    className='react-player'
                    playing
                    width='100%'
                    height='100%'
                    controls={true}
                />
            )
        }
    }
}

export function handleSnippet(is_sender, attachment_type) {
    if (!attachment_type) return;

    const sender = is_sender === 'page' ? 'Bạn đã' : 'Đã';
    const attachmentMap = {
        image: 'gửi một ảnh',
        file: 'gửi một tệp',
        video: 'gửi một video',
        audio: 'gửi một file âm thanh'
    };

    return attachmentMap[attachment_type] ? `${sender} ${attachmentMap[attachment_type]}` : undefined;
}

export const CustomerScheduleType = [
    { label: "Tư vấn", value: 'TUVAN', color: '#191970' },
    { label: "Điều trị", value: 'LAMDICHVU', color: '#00A36C' },
    { label: "Tái khám", value: 'TAIKHAM', color: '#1F51FF' },
    { label: "Gọi lại", value: 'GOILAI', color: '#724c00' },
    { label: "Chưa xác định lịch", value: 'CHUAXACDINHLICH', color: '#A52A2A' },
    //{ label: "Chưa đặt được lịch", value: 'CHUADATDUOCLICH', color: '#ff0000' },
    { label: "Khác", value: 'KHAC', color: '#EADDCA' },
];

export function ConvertCustomerScheduleType(value) {
    if (!value) return "";
    const result = CustomerScheduleType.map((item, index) => {
        if (item.value == value) {
            // return (<Tag key={index} color={item.color}>{item.label}</Tag>);
            return (<span key={index} style={{ color: item.color }}>{item.label}</span>);
        }
    })
    return result;
}

export const CustomerScheduleStatus = [
    //{ label: "Đã đến", value: 'daden', color: '#389e0d' },          // Xanh lá đậm
    //{ label: "Đang chờ (đã đến)", value: 'dangcho', color: '#fff176' },       // 🌼 Vàng nhạt
    { label: "Đang chờ (đã đến)", value: 'daden', color: '#fff176' },
    { label: "Đang trong ca", value: 'dangtrongca', color: '#1890ff' }, // 💙 Xanh nước biển
    { label: "Đã xong", value: 'daxong', color: '#52c41a' },         // 💚 Xanh lá tươi
    { label: "Chưa đến", value: 'chuaden', color: '' },       // Vàng cam
    { label: "Đã hủy", value: 'dahuy', color: '#ff7f50' }            // 🧡 Carrot
];


export const CustomerScheduleTeleStatus = [
    { label: "Đã gọi", value: 'dagoi', color: '#237600' },
    { label: "Chưa gọi", value: 'chuagoi', color: '#764f00' }
];

export const CustomerScheduleNaStatus = [
    { label: "Đã chuyển lịch", value: 'dachuyenlich', color: '#c5c5c5' },
    //{ label: "Không xác định", value: 'na', color: 'red' }
];

export function ConvertCustomerScheduleStatus(value, isButton = false) {
    if (!value) return "";
    const mergedArray = CustomerScheduleStatus.concat(CustomerScheduleTeleStatus);
    const mergedArray2 = mergedArray.concat(CustomerScheduleNaStatus);
    const result = mergedArray2.map((item, index) => {
        if (item.value === value) {
            if (!isButton) {
                return (<Tag style={{ color: '#000' }} key={index} color={item.color}>{item.label}</Tag>);
            } else {
                return item.label;
            }
        }
    })
    return result;
}

export const customerGender = [
    { label: "Nam", value: 'nam', color: '#1F51FF' },
    { label: "Nữ", value: 'nu', color: '#00A36C' },
    //{ label: "Khác", value: 'khac', color: '#EADDCA' },
];
export function ConvertcustomerGender(value) {
    if (!value) return "";
    const result = customerGender.map((item, index) => {
        if (item.value == value) {
            return (<span key={index}>{item.label}</span>);
        }
    })
    return result;
}

export const potentialProfileStatus = [
    { label: 'Đã tạo', value: 'created', color: 'green' },
    { label: 'Chưa tạo', value: 'not_created', color: 'yellow' },
];

export function ConvertPotentialProfileStatus(value) {
    if (!value) return "";
    const result = potentialProfileStatus.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result;
}

export const orthodonticPlanTypes = [
    { label: "Lần 1", value: "type1", color: "green" },
    { label: "Lần 2", value: "type2", color: "blue" },
    { label: "Lần 3", value: "type3", color: "red" },
];

export function ConvertOrthodonticPlanType(value) {
    if (!value) return null;
    const type = orthodonticPlanTypes.find((item) => item.value === value);
    return type ? <Tag color={type.color}>{type.label}</Tag> : null;
}


export const ProductReceiptImportType = [
    { label: "Mua mới", value: 'muamoi', color: '#228B22' },
    { label: "Trả hàng", value: 'trahang', color: '#454B1B' },
    { label: "Đổi hàng", value: 'doihang', color: '#082752ff' },
    { label: "Hoàn về kho", value: 'hoanvekho', color: '#088F8F' },
    { label: "Nhận chuyển kho", value: 'nhanchuyenkho', color: '#5F9EA0' },
    //{ label: "Thu hồi", value: 'thuhoi', color: '#AFE1AF' },
    { label: "Nhập dữ liệu", value: 'nhapdulieu', color: '#5F8575' }
];

export function ConvertProductReceiptImportType(value) {
    if (!value) return "";
    const result = ProductReceiptImportType.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const ProductReceiptExportType = [
    { label: "Cở sở sử dụng", value: 'cososudung', color: '#108ee9' },
    { label: "Chuyển kho", value: 'chuyenkho', color: '#faad14' },
    { label: "Bán", value: 'ban', color: '#183940' },
    { label: "Xuất cho khách", value: 'xuatchokhach', color: '#0d32e5' },
    { label: "Trả hàng", value: 'trahang', color: '#ff4d4f' },
    { label: "Khác", value: 'khac', color: '#00000073' }
];

export function ConvertProductReceiptExportType(value) {
    if (!value) return "";
    const result = ProductReceiptExportType.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const PaymentVoucherStatus = [
    { label: "Đã chi", value: 'dachi', color: '#52c41a' },
    { label: "Chưa chi", value: 'chuachi', color: '#183940' },
    { label: "Đã hoàn thành", value: 'dahoanthanh', color: '#108ee9' },
    { label: "Chưa hoàn thành", value: 'chuahoanthanh', color: '#faad14' }
];

export function ConvertPaymentVoucherStatus(value) {
    if (!value) return "";
    const result = PaymentVoucherStatus.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export function ConvertPaymentVoucherStatusInList(value) {
    if (!value) return "";
    const result = PaymentVoucherStatus.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} icon={<EditOutlined />} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const CashReceiptStatus = [
    { label: "Đã thanh toán", value: 'dathanhtoan', color: '#108ee9' },
    { label: "Đã hoàn thành", value: 'dahoanthanh', color: '#52c41a' },
    //{ label: "Chưa hoàn thành", value: 'chuahoanthanh', color: '#faad14' }
];

export function ConvertCashReceiptStatus(value) {
    if (!value) return "";
    const result = CashReceiptStatus.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export function ConvertCashReceiptStatusInList(value) {
    if (!value) return "";
    const result = CashReceiptStatus.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} icon={<EditOutlined />} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const PaymentMethod = [
    { label: "Tiền mặt", value: 'tienmat', color: 'geekblue' },
    { label: "Chuyển khoản", value: 'chuyenkhoan', color: 'gold' },
    { label: "Thanh toán thẻ", value: 'thanhtoanthe', color: 'lime' },
    //{ label: "Khác", value: 'khac', color: '' }
];

export function ConvertPaymentMethod(value) {
    if (!value) return null;

    const matchedMethod = PaymentMethod.find(item => item.value === value);

    if (!matchedMethod) return null;

    return <Tag style={{ border: 'none' }} color={matchedMethod.color}>{matchedMethod.label}</Tag>;
}

export const PaymentType = [
    { label: "Đăng ký dịch vụ", value: 'dkdichvu', color: 'blue' },
    { label: "Thanh toán tiếp", value: 'trano', color: 'red' },
    { label: "Hoàn tiền", value: 'hoantien', color: 'green' },
];

export function ConvertPaymentType(value) {
    if (!value) return null;

    const matchedType = PaymentType.find(item => item.value === value);

    if (!matchedType) return null;

    return <Tag style={{ border: 'none' }} color={matchedType.color}>{matchedType.label}</Tag>;
}

export const ReceiptType = [
    { label: "Phiếu thường", value: 'normal', color: 'blue' },
    { label: "Chuyển đổi dịch vụ", value: 'service_conversion', color: 'orange' },
];

export function ConvertReceiptType(value) {
    if (!value) return null;

    const matchedType = ReceiptType.find(item => item.value === value);

    if (!matchedType) return null;

    return <Tag style={{ border: 'none' }} color={matchedType.color}>{matchedType.label}</Tag>;
}


export const CustomerCardStatus = [
    { label: "Không áp dụng", value: 'none', color: 'red' },
    { label: "Đăng ký mở thẻ", value: 'dkmothe', color: 'blue' },
    { label: "Đã phát hành", value: 'daphathanh', color: 'geekblue' },
    { label: "Đã phát thẻ", value: 'daphatthe', color: 'green' },
];

export function ConvertCustomerCardStatus(value) {
    if (!value) return null;

    const matchedValue = CustomerCardStatus.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const RewardType = [
    { label: "Giải nhất", value: 'giainhat', color: '#52c41a' },
    { label: "Giải nhì", value: 'giainhi', color: '#108ee9' },
    { label: "Giải ba", value: 'giaiba', color: '#183940' },
];

export function ConvertRewardType(value) {
    if (!value) return "";
    const result = RewardType.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const MediaLibraryType = [
    { label: "Ảnh khách hàng", value: 'anhkhachhang', color: 'blue' },
    { label: "Ảnh cơ sở", value: 'anhcoso', color: 'yellow' },
    { label: "Ảnh quảng cáo", value: 'anhquangcao', color: 'green' },
    { label: "Ảnh hồ sơ, hợp đồng", value: 'anhhopdong', color: 'geekblue' }
];

export function ConvertMediaLibraryType(value) {
    if (!value) return "";
    const result = MediaLibraryType.map((item, index) => {
        if (item.value == value) {
            return (<Tag key={index} color={item.color}>{item.label}</Tag>);
        }
    })
    return result
}

export const PaymentMethods = [
    { label: "Trả thẳng", value: 'trathang', color: 'geekblue' },
    { label: "Trả góp tại nha khoa", value: 'tragoptainhakhoa', color: 'red' },
    { label: "Trả góp tại ngân hàng", value: 'tragoptainganhang', color: 'lime' }
];

export function RenderPaymentMethods(value) {
    if (!value) return null;

    const matchedMethod = PaymentMethods.find(item => item.value === value);

    if (!matchedMethod) return null;

    return <Tag className='payment-method' style={{ border: 'none' }} color={matchedMethod.color}>{matchedMethod.label}</Tag>;
}

export const PaymentStatus = [
    { label: "Đã trả", value: 'paid', color: 'blue' },
    { label: "Đang trả góp", value: 'installment', color: 'yellow' },
    { label: "Đã trả hết", value: 'completed', color: 'green' }
];

export function RenderPaymentStatus(value) {
    if (!value) return null;

    const matchedValue = PaymentStatus.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const CustomerServiceStatus = [
    { label: "Đang làm", value: 'danglam', color: 'blue' },
    { label: "Đã hoàn thành", value: 'dahoanthanh', color: 'green' },
    { label: "Đã đặt cọc", value: 'dadatcoc', color: 'orange' },
    { label: "Chưa làm", value: 'chualam', color: 'yellow' },
];

export function RenderCustomerServiceStatus(value) {
    if (!value) return null;

    const matchedValue = CustomerServiceStatus.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const afterServiceCare = [
    { label: "Có", value: 1, color: 'coral' },
    { label: "Không", value: 0, color: '#8080806b' },
];

export function RenderAfterServiceCare(value, isButton = false) {
    if (typeof value === "undefined") return null; // Chỉ bỏ qua nếu value chưa được định nghĩa

    const matchedValue = afterServiceCare.find(item => item.value === value);

    if (!matchedValue) return null;

    if (!isButton) {
        return (<Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>);
    } else {
        return matchedValue.label;
    }
}


export const commissionRules = [
    { label: "Percentage", value: 'percentage', color: 'blue' },
    { label: "Fixed", value: 'fixed', color: 'green' }
];

export function RenderCommissionRules(value) {
    if (!value) return null;

    const matchedValue = commissionRules.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const commissionPeriod = [
    { label: "Installment", value: 'installment', color: 'yellow' },
    { label: "Total", value: 'total', color: 'red' }
];

export function RenderCommissionPeriod(value) {
    if (!value) return null;

    const matchedValue = commissionPeriod.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const teams = [
    { label: "Bác sĩ", value: 'doctor', color: 'yellow' },
    { label: "Tư vấn", value: 'consultant', color: 'geekblue' },
    { label: "Telesale", value: 'telesale', color: 'lime' }
];

export function RenderTeams(value) {
    if (!value) return null;

    const matchedValue = teams.find(item => item.value === value);

    if (!matchedValue) return null;

    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export const customerTypes = [
    { label: "1. BHYT", value: 'bhyt', color: 'yellow' },
    { label: "2. Thu phí", value: 'thuphi', color: 'geekblue' },
    { label: "3. Miễn phí", value: 'mienphi', color: 'lime' },
    { label: "4. Khác", value: 'khac', color: 'lime' }
];

export function RenderCustomerType(value) {
    if (!value) return null;
    const matchedValue = customerTypes.find(item => item.value === value);
    if (!matchedValue) return null;
    return <Tag style={{ border: 'none' }} color={matchedValue.color}>{matchedValue.label}</Tag>;
}

export function isValidDateForm(dateField, show_default = true) {
    // Nếu không có dateField (null, undefined, rỗng), trả luôn fallback
    if (!dateField) {
        return show_default ? moment() : undefined;
    }

    const date = moment(dateField);
    return date.isValid() ? date : (show_default ? moment() : undefined);
}

export function formatDateForInputMask(dateField, show_time = false) {
    if (!dateField) return null;

    // DB trả về dạng YYYY-MM-DD → cần format lại
    const m = moment(dateField, 'YYYY-MM-DD', true);

    if (!m.isValid()) return null;

    return show_time ? m.format('DD/MM/YYYY HH:mm') : m.format('DD/MM/YYYY');
}

export function isValidDate(dateField, show_time = true) {
    if (!dateField) return "";

    const date = moment(dateField);
    if (!date.isValid()) return "";

    return date.format(show_time ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY');
}

export function renderDate(date, show_time = true) {
    const formattedDate = isValidDate(date, show_time);

    if (!formattedDate) {
        return <Text type="secondary">--</Text>;
    }

    return formattedDate;
}

// export function toMoment(value) {
//     if (!value) return null;
//     const date = moment(value);
//     return date.isValid() ? date : null;
// }

export function toMoment(value) {
    // Nếu null, undefined, hoặc chuỗi rỗng thì trả về null
    if (!value || value === "null" || value === "undefined" || value === "0000-00-00") {
        return null;
    }

    // Parse thử theo các định dạng phổ biến
    const date = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);

    // Nếu không hợp lệ thì trả null
    return date.isValid() ? date : null;
}

export function isValidateTime(datetime) {
    if (!datetime) return "";
    return moment(datetime).isValid() ? moment(datetime).format('HH:mm') : "";
}

export function formatTime(timeString) {
    if (!timeString) return "";

    // Trường hợp đầu vào dạng "06:00:00"
    if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
        return timeString.substring(0, 5); // => "06:00"
    }

    // Trường hợp dùng moment để parse datetime
    return moment(timeString).isValid()
        ? moment(timeString).format("HH:mm")
        : "";
}

/**
 * Định dạng thời gian dạng 08h00, 13h45, v.v.
 * @param {string|Date} datetime - Giá trị thời gian
 * @returns {string} Chuỗi dạng "08h00" hoặc chuỗi rỗng nếu không hợp lệ
 */
export function formatTimeWithH(datetime) {
    if (!datetime) return "";
    const time = moment(datetime);
    if (!time.isValid()) return "";
    return `${time.format('HH')}h${time.format('mm')}`;
}

/**
 * Tính thời gian đợi giữa giờ hẹn và giờ lên ghế.
 * - Nếu nhỏ hơn 1 giờ → hiển thị phút
 * - Nếu >= 1 giờ → hiển thị giờ và phút
 * - Nếu khách lên sớm → hiển thị "Lên sớm"
 * - Nếu đúng giờ → hiển thị "Không đợi"
 * @param {string|Date} startTime - Giờ hẹn
 * @param {string|Date} chairTime - Giờ bắt đầu (lên ghế)
 * @returns {JSX.Element|null} JSX ví dụ:
 *   <>Đợi<br /><span style={{ paddingLeft: 25 }}>trong 15 phút</span></>
 *   hoặc <>Lên sớm</>
 */
export function calculateWaitMinutes(startTime, chairTime) {
    if (!startTime || !chairTime) return null;

    const start = moment(startTime);
    const chair = moment(chairTime);
    if (!start.isValid() || !chair.isValid()) return null;

    const diff = chair.diff(start, "minutes"); // số phút chênh lệch

    if (diff < 0) return <>Lên sớm</>;
    if (diff === 0) return <>Không đợi</>;

    const days = Math.floor(diff / (60 * 24));
    const hours = Math.floor((diff % (60 * 24)) / 60);
    const minutes = diff % 60;

    if (days >= 1) {
        return (
            <>
                Đợi<br />
                <span style={{ paddingLeft: 25 }}>
                    {days} ngày
                    {hours > 0 && ` ${hours} giờ`}
                    {minutes > 0 && ` ${minutes} phút`}
                </span>
            </>
        );
    } else if (diff < 60) {
        return <>Đợi {diff} phút</>;
    } else {
        return minutes > 0 ? (
            <>
                {/* Đợi<br /><span style={{ paddingLeft: 25 }}>{hours} giờ {minutes} phút</span> */}
                Đợi {hours} giờ {minutes} phút
            </>
        ) : (
            <>Đợi {hours} giờ</>
        );
    }
}

// export function calculateWaitMinutes(startTime, chairTime) {
//     if (!startTime || !chairTime) return null;

//     const start = moment(startTime);
//     const chair = moment(chairTime);
//     if (!start.isValid() || !chair.isValid()) return null;

//     const diff = chair.diff(start, "minutes"); // số phút chênh lệch

//     if (diff < 0) return <>Lên sớm</>;
//     if (diff === 0) return <>Không đợi</>;

//     if (diff < 60) {
//         return (
//             <>
//                 Đợi {diff} phút
//             </>
//         );
//     } else {
//         const hours = Math.floor(diff / 60);
//         const minutes = diff % 60;

//         return minutes > 0 ? (
//             <>
//                 Đợi<br /> <span style={{ paddingLeft: 25 }}>{hours} giờ {minutes} phút</span>
//             </>
//         ) : (
//             <>
//                 Đợi {hours} giờ
//             </>
//         );
//     }
// }


/**
 * Tính thời gian hoàn thành giữa giờ bắt đầu và giờ kết thúc.
 * - Nếu nhỏ hơn 1 giờ → hiển thị phút
 * - Nếu >= 1 giờ → hiển thị giờ và phút
 * @param {string|Date} startTime - Giờ bắt đầu (lên ghế)
 * @param {string|Date} endTime - Giờ hoàn thành (time_to)
 * @returns {string} Ví dụ: "Hoàn thành trong 35 phút", "Hoàn thành sau 2 giờ 10 phút", hoặc ""
 */
export function calculateCompleteTimeText(startTime, endTime) {
    if (!startTime || !endTime) return null;
    const start = moment(startTime);
    const end = moment(endTime);
    if (!start.isValid() || !end.isValid()) return null;

    const diff = end.diff(start, "minutes");
    if (diff < 0) return <>N/a</>;
    if (diff === 0) return <>Hoàn thành ngay</>;

    if (diff < 60) {
        return <>Hoàn thành<br /><span style={{ paddingLeft: 25 }}>trong {diff} phút</span></>;
    } else {
        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;
        return minutes > 0 ? (
            <>Hoàn thành<br /><span style={{ paddingLeft: 25 }}>sau {hours} giờ {minutes} phút</span></>
        ) : (
            <>Hoàn thành<br /><span style={{ paddingLeft: 25 }}>sau {hours} giờ</span></>
        );
    }
}

/**
 * Tính thời gian chờ theo thời gian thực giữa giờ hẹn và thời gian hiện tại.
 * - Nếu nhỏ hơn 1 giờ → hiển thị phút
 * - Nếu >= 1 giờ → hiển thị giờ và phút
 * - Nếu chưa đến giờ hẹn → không hiển thị
 * @param {string|Date} appointmentTime - Giờ khách đến (time_to)
 * @param {moment.Moment} currentTime - Thời gian hiện tại
 * @returns {JSX.Element|null} Ví dụ: <>"Đợi<br/>trong 12 phút"</>, <>"Đợi<br/>sau 2 giờ 5 phút"</>, hoặc null
 */
export const calculateWaitMinutesRealtime = (appointmentTime, currentTime) => {
    if (!appointmentTime || !currentTime) return null;

    const start = moment(appointmentTime);
    const now = moment(currentTime);

    if (!start.isValid() || !now.isValid()) return null;
    if (now.isBefore(start)) return null;

    const diff = now.diff(start, 'minutes');
    if (diff <= 0) return null;

    const days = Math.floor(diff / (60 * 24));
    const hours = Math.floor((diff % (60 * 24)) / 60);
    const minutes = diff % 60;

    if (days >= 1) {
        return (
            <>
                Đang đợi<br />
                <span style={{ paddingLeft: 18 }}>
                    {days} ngày
                    {hours > 0 && ` ${hours} giờ`}
                    {minutes > 0 && ` ${minutes} phút`}
                </span>
            </>
        );
    } else if (diff < 60) {
        return <>Đang đợi {diff} phút</>;
    } else {
        return minutes > 0 ? (
            <>
                {/* Đang đợi<br /><span style={{ paddingLeft: 18 }}> {hours} giờ {minutes} phút</span> */}
                Đang đợi {hours} giờ {minutes} phút
            </>
        ) : (
            <>Đang đợi {hours} giờ</>
        );
    }
};

// export const calculateWaitMinutesRealtime = (appointmentTime, currentTime) => {
//     if (!appointmentTime || !currentTime) return null;

//     const start = moment(appointmentTime);
//     const now = moment(currentTime);

//     if (!start.isValid() || !now.isValid()) return null;
//     if (now.isBefore(start)) return null;

//     const diff = now.diff(start, 'minutes');
//     if (diff <= 0) return null;

//     if (diff < 60) {
//         return (
//             <>
//                 Đang đợi {diff} phút
//             </>
//         );
//     } else {
//         const hours = Math.floor(diff / 60);
//         const minutes = diff % 60;
//         return minutes > 0 ? (
//             <>
//                 {/* Đang đợi<br /><span style={{ paddingLeft: 18 }}> {hours} giờ {minutes} phút</span> */}
//                 Đang đợi {hours} giờ {minutes} phút
//             </>
//         ) : (
//             <>
//                 Đang đợi {hours} giờ
//             </>
//         );
//     }
// };


export function repeatPhoneNumber(input) {
    if (!input || input.length <= 3) return input;
    const maskedNumber = "*".repeat(input.length - 3) + input.slice(-3);
    return maskedNumber;
}

// Hàm tạo chuỗi ngẫu nhiên không trùng lặp với độ dài cố định
export function generateUniqueString(length = 5) {
    const timestamp = new Date().getTime();
    const randomPart = Math.random().toString(36).substr(2, length - 10).toUpperCase();
    const uniqueString = timestamp.toString(36).substr(2, 10) + randomPart;
    return uniqueString.toUpperCase();
}


export function replaceHeadingsWithDivs(htmlContent) {
    // Create a temporary div element
    const tempDiv = document.createElement('div');

    // Set the innerHTML of the temporary div with the provided HTML content
    tempDiv.innerHTML = htmlContent;

    // Get all headings from h1 to h6 within the temporary div
    const headings = tempDiv.querySelectorAll("h1, h2, h3, h4, h5, h6");

    // Iterate through each heading and replace with div
    headings.forEach((heading) => {
        const div = document.createElement("div");
        div.innerHTML = heading.innerHTML;
        heading.parentNode.replaceChild(div, heading);
    });

    // Remove empty tags
    removeEmptyTags(tempDiv);

    // Optionally, log or return the modified HTML content
    const modifiedHtmlContent = tempDiv.innerHTML;
    //console.log(modifiedHtmlContent);

    // Clean up any resources (if needed)
    // Note: Since we're not using useEffect, cleanup can be done here directly

    // Return the modified HTML content
    return modifiedHtmlContent;
}

function removeEmptyTags(element) {
    // Get all child nodes of the element
    const childNodes = element.childNodes;

    // Iterate through each child node
    for (let i = childNodes.length - 1; i >= 0; i--) {
        const child = childNodes[i];

        // Check if the child node is an element
        if (child.nodeType === 1) {
            // Recursively remove empty tags in the child element
            removeEmptyTags(child);

            // If the element has no children and no text content, remove it
            if (!child.hasChildNodes() && !child.textContent.trim()) {
                element.removeChild(child);
            }
        }
    }
}

export function renderTelesaleTime(inputDeadline, time_finish, position = null) {
    if (inputDeadline && time_finish) {
        var diff = moment(inputDeadline, 'YYYY-MM-DD HH:mm').diff(moment(time_finish, 'YYYY-MM-DD HH:mm'));
        var diffDuration = moment.duration(diff);

        var days = diffDuration.days();
        var hours = diffDuration.hours();
        var minutes = diffDuration.minutes();

        var show_text;
        var badge_color;

        if (days || hours || minutes) {
            if (days > 0 || hours > 0 || minutes > 0) {
                show_text = `Trước ${days} ngày, ${hours} giờ, ${minutes} phút`;
                if (days == 0) {
                    show_text = `Trước ${hours} giờ, ${minutes} phút`;
                }
                if (hours == 0) {
                    show_text = `Trước ${minutes} phút`;
                }
                badge_color = '#52c41a';
            } else {
                show_text = `Quá ${-days} ngày, ${-hours} giờ, ${-minutes} phút`;
                badge_color = 'red';
            }
        } else {
            show_text = "Đúng hạn";
            badge_color = '#52c41a';
        }
        if (position === 'detail') {
            return (
                <span>{isValidDate(time_finish, true)} &nbsp; <Tag color={badge_color}>{show_text}</Tag></span>
            );
        } else {
            return (
                <Badge count={show_text} size='small' className='custom-badge' color={badge_color}>
                    <span>{isValidDate(time_finish, true)}</span>
                </Badge>
            );
        }
    }

    return null; // Trả về null nếu không có thời gian telesale
}

export function renderTelesaleDeadline(deadline, status, position = null) {
    if (deadline) {
        var deadlineMoment = moment(deadline, 'YYYY-MM-DD HH:mm');
        var isAfter = deadlineMoment.isAfter(moment());
        var show_text;
        var badge_color;

        if (isAfter) {
            var diffDuration = moment.duration(deadlineMoment.diff(moment()));

            if (diffDuration.asDays() >= 1) {
                show_text = `Còn ${Math.floor(diffDuration.asDays())} ngày, ${diffDuration.hours()} giờ, ${diffDuration.minutes()} phút`;
            } else if (diffDuration.asHours() > 0) {
                show_text = `Còn ${Math.floor(diffDuration.asHours())} giờ, ${diffDuration.minutes()} phút`;
            } else if (diffDuration.asMinutes() > 0) {
                show_text = `Còn ${Math.floor(diffDuration.asMinutes())} phút`;
            } else {
                show_text = `Còn vài giây`;
            }

            badge_color = '#52c41a';
        } else {
            var diffDurationOvertime = moment.duration(moment().diff(deadlineMoment));

            if (diffDurationOvertime.asDays() > 0) {
                show_text = `Quá ${Math.floor(diffDurationOvertime.asDays())} ngày, ${diffDurationOvertime.hours()} giờ`;
            } else if (diffDurationOvertime.asHours() > 0) {
                show_text = `Quá ${Math.floor(diffDurationOvertime.asHours())} giờ, ${diffDurationOvertime.minutes()} phút`;
            } else if (diffDurationOvertime.asMinutes() > 0) {
                show_text = `Quá ${Math.floor(diffDurationOvertime.asMinutes())} phút`;
            } else {
                show_text = `Quá vài giây`;
            }

            if (diffDurationOvertime.asHours() < 1) {
                show_text = `Quá ${Math.floor(diffDurationOvertime.asMinutes())} phút`;
            }

            if (diffDurationOvertime.asDays() < 1) {
                show_text = `Quá ${diffDurationOvertime.hours()} giờ ${diffDurationOvertime.minutes()} phút`;
            }

            badge_color = 'red';
        }

        if (status === 1) { // Đã hoàn thiện
            return (
                <span>{deadlineMoment.format('DD/MM/YYYY HH:mm')}</span>
            )
        } else {
            if (position === 'detail') {
                return (
                    <>{deadlineMoment.format('DD/MM/YYYY HH:mm')} &nbsp; <Tag color={badge_color}>{show_text}</Tag></>
                )
            } else {
                return (
                    <Badge count={show_text} size='small' className='custom-badge' color={badge_color}>
                        {deadlineMoment.format('DD/MM/YYYY HH:mm')}
                    </Badge>
                )
            }
        }
    }
    return null;
}

export function processHTML(htmlContent) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(htmlContent, 'text/html');
    const images = htmlDoc.getElementsByTagName('img');

    for (let i = 0; i < images.length; i++) {
        const img = images[i];
        img.removeAttribute('width');
        img.removeAttribute('height');
    }

    return htmlDoc.body.innerHTML;
}

export function moneyToWord(number) {

    const hh1 = ' ';
    const hh2 = '  ';
    const hh3 = ' ';
    const hh4 = 'negative ';
    const hh5 = ' point ';
    const ht = {
        0: 'không',
        1: 'một',
        2: 'hai',
        3: 'ba',
        4: 'bốn',
        5: 'năm',
        6: 'sáu',
        7: 'bảy',
        8: 'tám',
        9: 'chín',
        10: 'mười',
        11: 'mười một',
        12: 'mười hai',
        13: 'mười ba',
        14: 'mười bốn',
        15: 'mười năm',
        16: 'mười sáu',
        17: 'mười bảy',
        18: 'mười tám',
        19: 'mười chín',
        20: 'hai mươi',
        30: 'ba mươi',
        40: 'bốn mươi',
        50: 'năm mươi',
        60: 'sáu mươi',
        70: 'bảy mươi',
        80: 'tám mươi',
        90: 'chín mươi',
        100: 'trăm',
        1000: 'ngàn',
        1000000: 'triệu',
        1000000000: 'tỷ',
        1000000000000: 'nghìn tỷ',
        1000000000000000: 'ngàn triệu triệu',
        1000000000000000000: 'tỷ tỷ'
    };

    if (isNaN(number)) {
        return false;
    }
    if ((number >= 0 && parseInt(number) < 0) || parseInt(number) < 0 - Number.MAX_SAFE_INTEGER) {
        // overflow
        console.warn('moneyToWord only accepts numbers between -' + Number.MAX_SAFE_INTEGER + ' and ' + Number.MAX_SAFE_INTEGER);
        return false;
    }
    if (number < 0) {
        return hh4 + moneyToWord(Math.abs(number));
    }

    let string = null;
    let fraction = null;

    if (number.toString().includes('.')) {
        [number, fraction] = number.toString().split('.');
    }

    switch (true) {
        case number < 21:
            string = ht[number];
            break;
        case number < 100:
            const tens = Math.floor(number / 10) * 10;
            const units = number % 10;
            string = ht[tens];
            if (units) {
                string += hh1 + ht[units];
            }
            break;
        case number < 1000:
            const hundreds = Math.floor(number / 100);
            const remainder = number % 100;
            string = ht[hundreds] + ' ' + ht[100];
            if (remainder) {
                string += hh2 + moneyToWord(remainder);
            }
            break;
        default:
            const baseUnit = Math.pow(1000, Math.floor(Math.log10(number) / 3));
            const numBaseUnits = Math.floor(number / baseUnit);
            const remainderValue = number % baseUnit;
            string = moneyToWord(numBaseUnits) + ' ' + ht[baseUnit];
            if (remainderValue) {
                string += remainderValue < 100 ? hh2 : hh3;
                string += moneyToWord(remainderValue);
            }
            break;
    }

    if (fraction !== null && !isNaN(fraction)) {
        string += hh5;
        const words = fraction.split('').map(num => ht[num]);
        string += words.join(' ');
    }

    return string;
}

export function generateDots(totalDots) {
    const dot = [];
    for (let i = 0; i < totalDots; i++) {
        dot.push(
            <React.Fragment key={i}>.</React.Fragment>
        );
    }
    return dot;
}

export function jsonViewer(text) {
    if (typeof text === 'string' && text.startsWith('[')) {
        // return (
        //     <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        //         {JSON.stringify(JSON.parse(text), null, 2)}
        //     </div>
        // );
        return (
            <ReactJson
                src={JSON.parse(text)}
                collapsed={false}
                theme="monokai"
                enableClipboard={false}
                displayObjectSize={false}
                displayDataTypes={false}
            />
        )
    } else if (typeof text === 'string' && text.length > 50) {
        return (
            <div style={{ width: '300px' }}>
                {stripHtml(text)}
            </div>
        );
    } else {
        return stripHtml(text);
    }
}

export function getFirstLetters(input) {
    try {
        // Kiểm tra nếu input không phải là chuỗi hoặc không hợp lệ
        if (typeof input !== 'string' || !input.trim()) {
            throw new Error('Input không hợp lệ. Vui lòng nhập một chuỗi không rỗng.');
        }

        // Loại bỏ các ký tự đặc biệt không mong muốn và cắt chuỗi thành các từ
        const sanitizedInput = input.replace(/[^a-zA-Z\u00C0-\u1EF9\s]/g, '').trim();
        const words = sanitizedInput.split(/\s+/);

        // Lấy chữ cái đầu tiên của hai từ đầu tiên
        const firstLetters = words.slice(0, 2).map(word => word.charAt(0).toUpperCase());

        // Ghép lại thành chuỗi
        return firstLetters.join('');
    } catch (error) {
        console.error('Lỗi:', error.message);
        return ''; // Trả về giá trị mặc định
    }
}

export const generateId = () => {
    const timestamp = Date.now(); // Lấy thời gian hiện tại (milisecond)
    const random = Math.random().toString(36).substr(2, 9); // Sinh ngẫu nhiên
    return `${timestamp}${random}`; // Kết hợp thời gian và số ngẫu nhiên
};

export const occupationOptions = [
    {
        group: "Văn phòng & Kinh doanh",
        options: [
            { label: "Nhân viên văn phòng", value: "NVVP" },
            { label: "Bán hàng", value: "BH" },
            { label: "Kinh doanh tự do", value: "KDTD" },
            { label: "Nhân viên kế toán", value: "NVKT" },
            { label: "Chuyên viên tài chính", value: "CVTC" }
        ]
    },
    {
        group: "Công nghệ & Kỹ thuật",
        options: [
            { label: "Kỹ sư", value: "KS" },
            { label: "Lập trình viên", value: "LTV" },
            { label: "Thiết kế đồ họa", value: "TKDH" },
            { label: "Thợ điện", value: "TĐ" },
            { label: "Thợ xây", value: "TXAY" },
            { label: "Kỹ sư cơ khí", value: "KSKH" },
            { label: "Kỹ sư điện tử", value: "KSĐT" }
        ]
    },
    {
        group: "Marketing & Truyền thông",
        options: [
            { label: "Chuyên viên marketing", value: "CVMK" },
            { label: "Quản lý truyền thông", value: "QLTT" },
            { label: "Nhân viên PR", value: "NVPR" }
        ]
    },
    {
        group: "Y tế & Giáo dục",
        options: [
            { label: "Giáo viên", value: "GV" },
            { label: "Bác sĩ", value: "BS" },
            { label: "Y tá", value: "YT" },
            { label: "Nhân viên y tế", value: "NVYT" }
        ]
    },
    {
        group: "Dịch vụ khách hàng",
        options: [
            { label: "Nhân viên chăm sóc khách hàng", value: "NVCSKH" },
            { label: "Quản lý dịch vụ khách hàng", value: "QLDVKH" }
        ]
    },
    {
        group: "Nghệ thuật & Giải trí",
        options: [
            { label: "Diễn viên", value: "DV" },
            { label: "Ca sĩ", value: "CS" },
            { label: "Nghệ sĩ biểu diễn", value: "NSBD" },
            { label: "Nhà sản xuất phim", value: "NSX" }
        ]
    },
    {
        group: "Thể thao",
        options: [
            { label: "Vận động viên", value: "VDV" },
            { label: "Huấn luyện viên thể thao", value: "HLV" }
        ]
    },
    {
        group: "Môi trường & Nông nghiệp",
        options: [
            { label: "Kỹ sư môi trường", value: "KSMT" },
            { label: "Nông dân", value: "ND" },
            { label: "Nhà nghiên cứu môi trường", value: "NNMT" }
        ]
    },
    {
        group: "Bất động sản",
        options: [
            { label: "Chuyên viên bất động sản", value: "CVBĐS" },
            { label: "Môi giới bất động sản", value: "MGBĐS" },
            { label: "Quản lý bất động sản", value: "QLBĐS" }
        ]
    },
    {
        group: "Luật pháp",
        options: [
            { label: "Luật sư", value: "LS" },
            { label: "Công chứng viên", value: "CCV" },
            { label: "Chuyên viên pháp lý", value: "CVPL" }
        ]
    },
    {
        group: "Lao động phổ thông",
        options: [
            { label: "Lao động tự do", value: "LDTD" },
            { label: "Công nhân", value: "CN" },
            { label: "Nông dân", value: "ND" }
        ]
    },
    {
        group: "Khác",
        options: [
            { label: "Nội trợ", value: "NT" },
            { label: "Sinh viên", value: "SV" },
            { label: "Học sinh", value: "HS" },
            { label: "Khác", value: "KHAC" }
        ]
    }
];

export function ConvertOccupation(value) {
    if (!value) return null;

    // Tìm kiếm trong tất cả các nhóm
    for (let group of occupationOptions) {
        const matched = group.options.find(item => item.value === value);
        if (matched) {
            return <Tag style={{ border: 'none' }}>{matched.label}</Tag>;
        }
    }
    // Nếu không tìm thấy
    return null;
}

export const ethnicOptions = [
    { label: "Kinh", value: "kinh" },
    { label: "Tày", value: "tay" },
    { label: "Thái", value: "thai" },
    { label: "Mường", value: "muong" },
    { label: "Mông", value: "mong" },
    { label: "Nùng", value: "nung" },
    { label: "Khmer", value: "khmer" },
    { label: "Hoa", value: "hoa" },
    { label: "Dao", value: "dao" },
    { label: "Gia Rai", value: "gia_rai" },
    { label: "Ba Na", value: "ba_na" },
    { label: "Bố Y", value: "bo_y" },
    { label: "Brâu", value: "brau" },
    { label: "Bru-Vân Kiều", value: "bru_van_kieu" },
    { label: "Chăm", value: "cham" },
    { label: "Chơ Ro", value: "cho_ro" },
    { label: "Chu Ru", value: "chu_ru" },
    { label: "Chứt", value: "chut" },
    { label: "Co", value: "co" },
    { label: "Cơ Ho", value: "co_ho" },
    { label: "Cờ Lao", value: "co_lao" },
    { label: "Cơ Tu", value: "co_tu" },
    { label: "Cống", value: "cong" },
    { label: "Ê-Đê", value: "e_de" },
    { label: "Giáy", value: "giay" },
    { label: "Gié-Triêng", value: "gie_trieng" },
    { label: "Hà Nhì", value: "ha_nhi" },
    { label: "Hrê", value: "hre" },
    { label: "Kháng", value: "khang" },
    { label: "Khơ Mú", value: "kho_mu" },
    { label: "La Chí", value: "la_chi" },
    { label: "La Ha", value: "la_ha" },
    { label: "La Hủ", value: "la_hu" },
    { label: "Lào", value: "lao" },
    { label: "Lô Lô", value: "lo_lo" },
    { label: "Lự", value: "lu" },
    { label: "Mạ", value: "ma" },
    { label: "Mảng", value: "mang" },
    { label: "Mnông", value: "mnong" },
    { label: "Ngái", value: "ngai" },
    { label: "Ơ Đu", value: "o_du" },
    { label: "Pà Thẻn", value: "pa_then" },
    { label: "Phù Lá", value: "phu_la" },
    { label: "Pu Péo", value: "pu_peo" },
    { label: "Ra Glay", value: "ra_glay" },
    { label: "Rơ Măm", value: "ro_mam" },
    { label: "Sán Chay", value: "san_chay" },
    { label: "Sán Dìu", value: "san_diu" },
    { label: "Si La", value: "si_la" },
    { label: "Tà Ôi", value: "ta_oi" },
    { label: "Thổ", value: "tho" },
    { label: "Xinh Mun", value: "xinh_mun" },
    { label: "Xơ Đăng", value: "xo_dang" },
    { label: "Xtiêng", value: "xtieng" }
];

export function ConvertEthnic(value) {
    if (!value) return null;
    const matched = ethnicOptions.find(item => item.value === value);
    if (!matched) return null;
    return <Tag style={{ border: 'none' }}>{matched.label}</Tag>;
}

export const getActionColor = (action) => {
    switch (action) {
        case 'create':
            return 'green';
        case 'delete':
            return 'red';
        case 'rollback':
            return 'orange';
        case 'update':
            return 'blue';
        default:
            return 'default';
    }
};

export const renderBooleanIcon = (value) => {
    if (value === 1 || value === true) {
        return <CheckCircleTwoTone twoToneColor="#52c41a" />;
    }
    if (value === 0 || value === false) {
        return <CloseCircleTwoTone twoToneColor="#e74c3c" />;
    }
    return null;
};

export const renderYesNoText = (value) => {
    if (value === 1 || value === true) return 'Có';
    if (value === 0 || value === false) return 'Không';
    return '';
};

export const laboCaseStatuses = [
    { label: 'Chờ gửi', value: 'waiting', color: 'default' },
    { label: 'Đã gửi', value: 'sent', color: 'blue' },
    { label: 'Đã nhận từ labo', value: 'received', color: 'green' },
    { label: 'Đã trả cho khách', value: 'returned', color: 'red' },
    { label: 'Hoàn tất', value: 'completed', color: 'gold' }
];

export const renderLaboCaseStatusTag = (status) => {
    const item = laboCaseStatuses.find((s) => s.value === status);
    const label = item?.label || status;
    const color = item?.color || 'default';

    return <Tag color={color}>{label}</Tag>;
};

export const vatStatuses = [
    { label: 'Chờ VAT', value: 'vat_pending', color: 'orange' },
    { label: 'Có VAT', value: 'vat_included', color: 'green' },
    { label: 'Chưa VAT', value: 'vat_excluded', color: 'red' },
    // { label: 'VAT khác', value: 'vat_other', color: 'purple' },
    // { label: 'Hủy VAT', value: 'vat_cancelled', color: 'default' },
    // { label: 'VAT một phần', value: 'vat_partial', color: 'gold' }
];

export const renderVatStatusTag = (status) => {
    const item = vatStatuses.find((s) => s.value === status);
    const label = item?.label || status;
    const color = item?.color || 'default';

    return <Tag color={color}>{label}</Tag>;
};

export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === "") return "0 đ";

    const value = parseInt(amount, 10); // ép sang int
    if (isNaN(value)) return "0 đ";

    return value.toLocaleString("vi-VN", { style: "currency", currency: "VND" });
};

/*
Trạng thái răng
*/
export const TEETH_STATUS = {
    NONE: "none",
    IMPLANT: "implant",
    LOST: "lost",
    CROWN: "crown",
    BRIDGE: "bridge",
    DECAY: "decay",
    PULPITIS: "pulpitis",
    FRACTURE: "fracture",
    ABRASION: "abrasion",
};

export const TEETH_STATUS_LABEL = {
    [TEETH_STATUS.IMPLANT]: "Implant",
    [TEETH_STATUS.LOST]: "Đã mất",
    [TEETH_STATUS.CROWN]: "Chụp sứ",
    [TEETH_STATUS.BRIDGE]: "Cầu răng",
    [TEETH_STATUS.DECAY]: "Sâu răng",
    [TEETH_STATUS.PULPITIS]: "Viêm tủy",
    [TEETH_STATUS.FRACTURE]: "Mẻ răng",
    [TEETH_STATUS.ABRASION]: "Mòn cổ răng",
};

/**
 * Trả về nhãn tiếng Việt của trạng thái răng
 * @param {string} status
 * @returns {string}
 */
export function getTeethStatusLabel(status) {
    return TEETH_STATUS_LABEL[status] || status || "";
}

/**
 * Format ngày từ "YYYY-MM-DD HH:mm:ss" → "dd tháng MM năm yyyy"
 * Nếu không có giá trị thì dùng ngày hiện tại
 * @param {string | null} datetime
 * @returns {string}
 */
export function formatVietnameseDate(datetime) {
    let dateObj;

    try {
        if (datetime) {
            // Chuyển "2025-10-15 16:02:44" → "2025-10-15T16:02:44"
            dateObj = parseISO(datetime.replace(' ', 'T'));
        } else {
            dateObj = new Date(); // fallback ngày hiện tại
        }

        if (isNaN(dateObj)) dateObj = new Date(); // nếu lỗi parse thì fallback luôn
        return format(dateObj, "d 'tháng' M 'năm' yyyy", { locale: vi });
    } catch {
        return format(new Date(), "d 'tháng' M 'năm' yyyy", { locale: vi });
    }
}

// /**
//  * Hàm hiển thị giá trị (răng, khớp cắn, mặt phẳng, v.v.)
//  * ----------------------------------------------------------
//  * @param {Array} arr - Dữ liệu dạng mảng [{ has_occurrence, occurrence_detail }]
//  * @param {string|null} unit - Đơn vị hiển thị (ví dụ "mm", "cm") - nếu không truyền thì bỏ qua
//  * ----------------------------------------------------------
//  * - Nếu có occurrence_detail → hiển thị trong ngoặc
//  * - Nếu có unit → thêm đơn vị phía sau detail
//  * - Nếu không có detail → chỉ hiển thị has_occurrence
//  */
// export const renderRank = (arr, unit = null) => {
//     if (!Array.isArray(arr) || arr.length === 0) return null;

//     const item = arr[0];
//     const label = item?.has_occurrence?.trim();
//     const detail = item?.occurrence_detail?.trim();

//     if (!label) return null;

//     // Nếu có detail → hiển thị trong ngoặc
//     let formattedDetail = "";
//     if (detail) {
//         formattedDetail = unit
//             ? ` (${detail} ${unit})`
//             : ` (${detail})`;
//     }

//     return `${label}${formattedDetail}`;
// };

/**
 * Hàm hiển thị giá trị (răng, khớp cắn, mặt phẳng, v.v.)
 * ----------------------------------------------------------
 * @param {Array} arr - Dữ liệu dạng mảng [{ label, has_occurrence, occurrence_detail }]
 * @param {string|null} unit - Đơn vị hiển thị (ví dụ "mm", "cm") - nếu không truyền thì bỏ qua
 * ----------------------------------------------------------
 * - Nếu có occurrence_detail → hiển thị trong ngoặc
 * - Nếu có unit → thêm đơn vị phía sau detail
 * - Nếu không có detail → chỉ hiển thị has_occurrence
 * - Nếu có label → hiển thị "label: ..."
 * - Hợp nhất nhiều mục bằng dấu "; "
 * ----------------------------------------------------------
 * Ví dụ:
 * [
 *   { label: "Dị ứng", has_occurrence: "Không", occurrence_detail: "" },
 *   { label: "Bản thân", has_occurrence: "Có", occurrence_detail: "cản trở việc tập trung" }
 * ]
 * => "Dị ứng: Không; Bản thân: Có (cản trở việc tập trung)"
 */
export const renderRank = (arr, unit = null, hasLabel = true) => {
    if (!Array.isArray(arr) || arr.length === 0) return null;

    const formattedItems = arr.map((item) => {
        const label = item?.label?.trim() || "";
        const hasOccurrence = item?.has_occurrence?.trim() || "";
        const detail = item?.occurrence_detail?.trim() || "";

        if (!hasOccurrence && !label) return null; // bỏ qua nếu rỗng

        let formattedDetail = "";
        if (detail) {
            formattedDetail = unit ? ` (${detail} ${unit})` : ` (${detail})`;
        }

        const content = `${hasOccurrence}${formattedDetail}`;
        return label && hasLabel ? `${label}: ${content}` : content;
    }).filter(Boolean); // lọc bỏ null/undefined

    return formattedItems.join("; ");
};


/**
 * Hiển thị dữ liệu dạng HTML, mỗi mục 1 dòng, label tô đậm
 * ----------------------------------------------------------
 * @param {Array} arr - Mảng [{ label, has_occurrence, occurrence_detail }]
 * @param {string|null} unit - Đơn vị (vd: "mm") - tùy chọn
 * ----------------------------------------------------------
 * - Mỗi item hiển thị: <strong>Label:</strong> Giá trị (chi tiết)
 * - Có detail → hiển thị trong ngoặc, kèm đơn vị nếu có
 * - Tự động xuống dòng mỗi mục bằng <br/>
 * ----------------------------------------------------------
 * Ví dụ:
 * [
 *   { label: "Dị ứng", has_occurrence: "Không", occurrence_detail: "" },
 *   { label: "Bản thân", has_occurrence: "Có", occurrence_detail: "Cản trở việc tập trung" }
 * ]
 * =>
 * "<strong>Dị ứng:</strong> Không<br/><strong>Bản thân:</strong> Có (Cản trở việc tập trung)"
 */
export const renderRankHtml = (arr, unit = null) => {
    if (!Array.isArray(arr) || arr.length === 0) return "";

    const lines = arr
        .map((item) => {
            const label = item?.label?.trim() || "";
            const hasOccurrence = item?.has_occurrence?.trim() || "";
            const detail = item?.occurrence_detail?.trim() || "";

            if (!hasOccurrence && !label) return null;

            let formattedDetail = "";
            if (detail) {
                formattedDetail = unit ? ` (${detail} ${unit})` : ` (${detail})`;
            }

            const content = `${hasOccurrence}${formattedDetail}`;
            return `<strong>${label}:</strong> ${content}`;
        })
        .filter(Boolean);

    return lines.join("<br/>");
};

export function formatLastSeen(value) {
    if (!value) {
        return {
            text: 'Chưa có dữ liệu',
            tooltip: 'Chưa có dữ liệu hoạt động',
            isOnline: false
        };
    }

    const now = moment();
    const last = moment(value);

    const diffMinutes = now.diff(last, 'minutes');
    const diffHours = now.diff(last, 'hours');
    const diffDays = now.diff(last, 'days');
    const diffWeeks = now.diff(last, 'weeks');
    const diffMonths = now.diff(last, 'months');
    const diffYears = now.diff(last, 'years');

    const isOnline = diffMinutes <= 5; // hoạt động trong 5 phút gần nhất
    let text = '';
    let tooltip = '';

    if (isOnline) {
        text = 'Đang hoạt động';
        tooltip = `Đang hoạt động (${last.fromNow()})`;
    } else if (diffMinutes < 60) {
        text = `${diffMinutes} phút trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffHours < 24) {
        text = `${diffHours} giờ trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffDays === 1) {
        text = 'Hôm qua';
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffDays < 7) {
        text = `${diffDays} ngày trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffWeeks === 1) {
        text = 'Tuần trước';
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffWeeks < 5) {
        text = `${diffWeeks} tuần trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffMonths === 1) {
        text = 'Tháng trước';
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffMonths < 12) {
        text = `${diffMonths} tháng trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else if (diffYears === 1) {
        text = 'Năm trước';
        tooltip = `Hoạt động ${last.fromNow()}`;
    } else {
        text = `${diffYears} năm trước`;
        tooltip = `Hoạt động ${last.fromNow()}`;
    }

    return { text, tooltip, isOnline };
}

export const telesaleFollowStatuses = [
    { label: 'Chăm', value: 'cham', color: 'red' },
    { label: 'Follow', value: 'follow', color: 'green' },
    { label: 'Đã hẹn lịch', value: 'da_hen_lich', color: 'purple' },
    { label: 'Đã hủy', value: 'da_huy', color: 'default' },
    { label: 'Đã chốt', value: 'da_chot', color: 'magenta' },
    { label: 'Chưa chốt', value: 'chua_chot', color: 'lime' },
    { label: 'Chưa gọi được', value: 'chua_goi_duoc', color: 'blue' },
    { label: 'Không có nhu cầu', value: 'khong_co_nhu_cau', color: 'brown' },
    { label: 'Nhắc lịch', value: 'nhac_lich', color: 'purple' },
    { label: 'Ở xa', value: 'o_xa', color: 'volcano' },
    { label: 'Tham khảo', value: 'tham_khao', color: 'geekblue' },
];

export const renderTelesaleFollowStatusTag = (status) => {
    const item = telesaleFollowStatuses.find((s) => s.value === status);

    const label = item?.label || status;
    const color = item?.color || 'default';

    return <Tag color={color}>{label}</Tag>;
};

export const renderTelesaleAssignmentType = (type) => {
    switch (type) {
        case 'manual':
            return <span style={{ color: '#fa8c16', fontWeight: 500 }}>Chủ động</span>;
        case 'assigned':
        default:
            return <span style={{ color: '#1890ff', fontWeight: 500 }}>Được phân công</span>;
    }
};

// Normalize phones
export const buildPhonesPayload = (phones, familyMap = {}) => {
    return (phones || []).map(p => ({
        phone: p,
        confirmed_family: !!familyMap[p],
        related_customer_id: familyMap[p] || null,
    }));
};

// 
export const mergePhonesWithConfirmations = (rawPhones, confirmedPhones) => {
    const confirmedMap = _.keyBy(confirmedPhones, 'phone');

    return rawPhones.map(phone => {
        if (confirmedMap[phone]) {
            return {
                phone,
                confirmed_family: true,
                related_customer_id: confirmedMap[phone].related_customer_id,
            };
        }

        // phone không trùng → vẫn gửi lên
        return { phone };
    });
};

export const serviceGroups = [
    { label: 'Niềng răng', value: 'orthodontic', color: 'blue' },
    { label: 'Implant', value: 'implant', color: 'purple' },
    { label: 'Thẩm mỹ', value: 'cosmetic', color: 'magenta' },
    { label: 'Dịch vụ khác', value: 'other_service', color: 'default' },
    { label: 'Invisalign', value: 'invisalign', color: 'cyan' },
    { label: 'Sản phẩm khác', value: 'other_product', color: 'geekblue' },
    { label: 'Tăm nước', value: 'tam_nuoc', color: 'gold' },
    { label: 'NHA', value: 'nha', color: 'volcano' },
];

export function renderServiceGroup(value) {
    if (!value) return null;

    const matchedValue = serviceGroups.find(item => item.value === value);

    if (!matchedValue) return null;

    return (
        <Tag style={{ border: 'none' }} color={matchedValue.color}>
            {matchedValue.label}
        </Tag>
    );
}